import React, { useRef } from 'react';
var VeltMultiThreadCommentDialogMinimalFilterDropdownContentFilterResolved = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-filter-dropdown-content-filter-resolved", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltMultiThreadCommentDialogMinimalFilterDropdownContentFilterResolved;
